<template>
	<div>
		<div class="col-12 px-0">
			<div class="d-flex align-items-center justify-content-between mb-0">
				<div>
					<h5 class="font-weight-bold">Status de {{ tipo }}</h5>
				</div>

				<div>
					<div class="input-group mb-3">
						<b-input
							:placeholder="$t('Type to search')"
							class="form-control search-input"
							type="search"
							v-model="search"
							v-on:change="getListStatus"
							aria-describedby="input-search"
						/>
						<div class="input-group-append" role="button">
							<span class="input-group-text" id="input-search"
								><i class="fas fa-search search-icon"
							/></span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<form-input
				v-model="new_status"
				label="Status"
				grid="7"
				placeholder="Descrição do Status"
				:uppercase="tipo != 'Metas' ? true : false"
			/>
			<form-input-color label="Cor do Status" grid="3" v-model="color" />
			<div class="col-md-2 pl-0">
				<button class="btn btn-block btn-success btn-sm mt-4" @click="inserirStatus">
					Cadastrar
				</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<loading-animation
					:active.sync="loading"
					:is-full-page="false"
					:opacity="1"
					color="#5895FF"
				/>
				<b-table
					:fields="[
						{
							key: 'id',
							label: $t('ID'),
						},
						{
							key: 'titulo',
							label: $t('Nome'),
						},
						{
							key: 'origem',
							label: $t('Origem'),
						},
						{
							key: 'contagem',
							label: $t('Contagem'),
						},
						{
							key: 'actions',
							label: '',
							class: 'text-right',
							thStyle: { width: '95px', minWidth: '95px' },
						},
					]"
					:items="StatusList"
					:responsive="true"
					striped
					hover
					show-empty
					small
					outlined
					stacked="md"
					table-class="mb-3"
				>
					<template v-slot:cell(id)="data">
						{{ data.item.id }}
					</template>
					<template v-slot:cell(titulo)="data">
						<strong v-html="data.item.titulo"></strong>
					</template>
					<template v-slot:cell(origem)="data">
						{{ data.item.origem }}
					</template>
					<template v-slot:cell(contagem)="data">
						{{ data.item.contagem }}
					</template>
					<template v-slot:cell()="data">
						<b-button
							:title="$t('Mostrar Status')"
							@click="
								$bvModal.show('show-status');
								Statuselected = data.item;
							"
							class="px-2 mb-0"
							size="xs"
							type="button"
							v-b-tooltip.hover
							variant="success"
						>
							<i class="mdi mdi-square-edit-outline" />
						</b-button>
						<b-button
							v-if="data.item.origem != 'Sistema'"
							@click="excluir(data.item, modulo)"
							class="px-2 mb-0"
							size="xs"
							type="button"
							v-b-tooltip.hover
							variant="danger"
							><i class="mdi mdi-delete" />
						</b-button>
					</template>
					<template v-slot:empty="scope">
						<div class="text-center my-5">
							<img
								:alt="$t('No results')"
								class="mb-5"
								src="/img/icons/robot.svg"
								style="max-height: 165px"
							/>
							<h3 class="bold">{{ $t("No records found") }}</h3>
						</div>
					</template>
				</b-table>

				<div class="row align-items-center">
					<div class="col-lg-6 col-md-12">
						<div class="form-group d-inline-flex mb-0">
							<select
								class="form-control"
								style="width: 70px"
								v-model="perPage"
								@change="getListStatus"
							>
								<option value="5">5</option>
								<option value="10">10</option>
								<option value="25">25</option>
								<option value="50">50</option>
							</select>
						</div>
						<div class="d-inline-flex ml-2">
							<b-pagination
								:per-page="perPage"
								:total-rows="pagination.total"
								@change="changePage"
								v-model="page"
							/>
						</div>
					</div>
					<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
						<div class="float-lg-right">
							{{ $t("Showing page") }} {{ pagination.currentPage }}
							{{ $t("of") }}
							{{ pagination.totalPages }}
							{{ $t("pages in") }}
							{{ pagination.total }}
							{{ $t("records") }}
						</div>
					</div>
				</div>
			</div>
			<router-view />
		</div>
		<ModalStatus :item="Statuselected" @reload="getListStatus" />
	</div>
</template>
<script>
import ModalStatus from "./ModalStatus";
export default {
	components: { ModalStatus },
	props: ["tipo", "modulo", "model"],
	name: "Status",
	data() {
		return {
			Statuselected: "",
			StatusList: [],
			new_status: null,
			color: "#000",
			itens: [],
			page: 1,
			search: "",
			perPage: 10,
			loading: true,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
		};
	},
	watch: {
		tipo(n, o) {
			this.getListStatus();
		},
	},
	mounted() {
		this.getListStatus();
	},
	methods: {
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getListStatus();
			}
		},
		getListStatus() {
			this.loading = true;
			this.geStatus();
			axios
				.post("api/dashboard/admin/list/status", {
					model: this.model || this.modulo,
					module: this.modulo,
					page: this.page,
					search: this.search,
					perPage: this.perPage,
				})
				.then((response) => {
					this.StatusList = response.data.data;
					this.pagination = response.data.pagination;
					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getListStatus();
					} else {
						this.loading = false;
					}
				});
		},
		geStatus() {
			axios
				.post("api/dashboard/admin/getStatus", {
					model: this.model || this.modulo,
					module: this.modulo,
				})
				.then((response) => {
					this.setStatus(response.data.data);
				});
		},
		setStatus(data) {
			this.itens = data.map((elem) => ({
				id: elem.id,
				value: elem.descricao,
			}));
		},
		inserirStatus(status) {
			if (this.tipo != "Metas") {
				this.new_status = this.new_status.toUpperCase();
			}
			this.loading = true;
			axios
				.post("api/dashboard/admin/status", {
					descricao: this.new_status,
					cor: this.color,
					model: this.model || this.modulo,
					module: this.modulo,
				})
				.then((response) => {
					this.getListStatus();
					this.$snack.success({
						button: false,
						text: "Status cadastrado com sucesso.",
					});
					this.setStatus(response.data.data);
					this.new_status = "";
					this.color = "#000";
					this.loading = false;
				});
		},
		excluir(item, modulo) {
			axios
				.get(`api/dashboard/admin/excluir/status/${item.id}/${modulo}`)
				.then((response) => {
					this.getListStatus();
					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
				});
		},
	},
};
</script>
<style lang="css">
.list-group-item-action {
	cursor: pointer;
}
</style>
